import { IRestrictedMode, IRestrictedModeAction } from 'models/restrictedmode';

/** Action Types */
export const SET: string = 'restrictedmode/SET';

/** Counter: Initial State */
const initialState: IRestrictedMode = {
	isRestrictedMode: false,
};

export function restrictedModeReducer(state = initialState, action?: IRestrictedModeAction) {
	switch (action.type) {
		case SET:
			return {
				isRestrictedMode: action.payload.isRestrictedMode,
			};

		default:
			return state;
	}
}

export function setRestrictedMode(isRestrictedMode: boolean): IRestrictedModeAction {
	return {
		type: SET,
		payload: {
			isRestrictedMode,
		},
	};
}
